import { type EvalExecutionStatus } from '@libraries/typescript/api_client';

export const NONTERMINAL_EXECUTION_STATUSES: ReadonlySet<EvalExecutionStatus> =
    new Set(['queued', 'provisioning', 'running', 'packaging']);
